import { https } from "../http";
import store from "../store";
import {
  setNotificationLoading,
  setNotifications,
  setNotificationsCount,
  setReadAllNotifications,
  setReadNotification,
} from "../store/reducers/notification";
import { showError } from "../utils/index";

const getNotifications = async (payload) => {
  try {
    store.dispatch(setNotificationLoading(true));
    let response = await https().get(
      `/notification/get-all?page=${payload?.page}&perPage=${payload?.limit}&userId=${payload?.userId}${payload?.filter ? `&filter=${payload?.filter}` : ''}`
    );
    if (response) {
      store.dispatch(setNotifications(response.data));
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    showError(_error, error?.response?.status);
    store.dispatch(setNotificationLoading(false));
    return false;
  }
};

const getNotificationsCount = async (payload) => {
  try {
    // store.dispatch(setNotificationLoading(true));
    let response = await https().get(`/notification/get-count`);
    if (response) {
      store.dispatch(setNotificationsCount(response.data));

      // store.dispatch(setNotifications(response.data));
    }
  } catch (error) {
    // let _error = error?.response?.data?.message;
    // showError(_error, error?.response?.status);
    // store.dispatch(setNotificationLoading(false));
    return false;
  }
};

const readNotification = async (payload) => {
  try {
    let response = await https().post("/notification/read-notification", {
      notificationId: payload,
    });
    if (response) {
      store.dispatch(setReadNotification(response.data));
      return response?.data;
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    showError(_error, error?.response?.status);
  }
};

const readAllNotifications = async () => {
  try {
    let response = await https().post("/notification/read-all");
    if (response) {
      store.dispatch(setReadAllNotifications(true));
      return response?.data;
    }
  } catch (error) {
    console.log(error);
  }
};

const acceptProviderRequest = async (providerId, notificationId) => {
  try {
    let response = await https().post("/staff/accept-provider-request", { providerId, notificationId });
    return response?.status === 200;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const declineProviderRequest = async (providerId, notificationId) => {
  try {
    let response = await https().post("/staff/decline-provider-request", { providerId, notificationId });
    return response?.status === 200;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// Provider → Contractor flow: contractor accepts/declines a provider's request to add them
const acceptProviderConnectionRequest = async (notificationId) => {
  try {
    let response = await https().post("/skypointContractor/accept-provider", { notificationId });
    return response?.status === 200;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const declineProviderConnectionRequest = async (notificationId) => {
  try {
    let response = await https().post("/skypointContractor/decline-provider", { notificationId });
    return response?.status === 200;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

export {
  getNotifications,
  getNotificationsCount,
  readNotification,
  readAllNotifications,
  acceptProviderRequest,
  declineProviderRequest,
  acceptProviderConnectionRequest,
  declineProviderConnectionRequest,
};
